import React, {PropTypes} from 'react';
import {formatCurrency} from 'shared/util/formatCurrency';
Number.prototype.formatCurrency = formatCurrency;

const VirtualEntryPaymentLogReservation = ({
  reservationDescription,
  paymentDescription,
  transactionAmount,
  paymentAmount
}) => (
  <div>
    <div className="flex">
      <div className="flex-3">
        <small>{'Description'}</small>
        <div>{reservationDescription}</div>
      </div>
      <div className="flex-1">
        <div className="text-right">
          <small>{'Amount'}</small>
        </div>
        <div className="flex text-right">
          <span className="flex-2">{'Base Fee'}</span>
          <span className="flex-1">{`$${transactionAmount.formatCurrency(2)}`}</span>
        </div>
      </div>
    </div>
    {paymentDescription && paymentAmount
      ? <div className="flex">
          <div className="flex-3">
            <div>{paymentDescription}</div>
          </div>
          <div className="flex-1">
            <div className="flex text-right">
              <strong className="flex-2">{'Payment'}</strong>
              <strong className="flex-1">{`$${paymentAmount.formatCurrency(2)}`}</strong>
            </div>
          </div>
        </div>
      : null
    }
  </div>
);

VirtualEntryPaymentLogReservation.propTypes = {
  reservationDescription: PropTypes.string,
  paymentDescription: PropTypes.string,
  transactionAmount: PropTypes.number,
  paymentAmount: PropTypes.number
};

VirtualEntryPaymentLogReservation.defaultProps = {
  reservationDescription: '',
  paymentDescription: '',
  transactionAmount: 0,
  paymentAmount: 0
};

export default VirtualEntryPaymentLogReservation;



// WEBPACK FOOTER //
// ./src/features/registration/rostercheckout/VirtualEntryPaymentLogReservation.jsx